import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_293: DocMigration = {
  maxSchemaVersion: "0.0.293",
  description: "Fix casework edge ids malformed during edge remapping",
  apply(json: any): any {
    for (const caseworkId in json.casework) {
      const casework = json.casework[caseworkId];
      switch (casework.type) {
        case "FIXED":
        case "FIXED_V2":
          delete casework["edgeIds"];
          continue;
        default:
      }
    }
    return json;
  },
};

export default migration_0_0_293;
